// require utilities/generate_uuid // Can't actually require this because it's not an es6 file.

class TabBuilder {
  constructor(navigationClass, contentClass) {
    this.nav = jQuery(`<nav role="tablist" class="${navigationClass}"></nav>`);
    this.contentHolder = jQuery(`<div class="${contentClass}"></div>`);
    this.identifier = Sparkle.Utilities.generateUUID();
    this.tabs = [];
  }

  addTab(name, content, selected) {
    var tab = jQuery(
      `<label class="tab-selector" data-tab-name='${name}' for='tab_selector_${this.identifier}_${name}' role='tab'></label>`,
    );
    tab.append(
      `<input type='radio' ${selected ? "checked" : ""} title='${name}' name='tab_group_${this.identifier}' id='tab_selector_${this.identifier}_${name}' value='tab_${this.identifier}_${name}' data-behaviour="tabstate" aria-controls='tab_${this.identifier}_${name}'>`,
    );
    tab.append(`<span class='tab-label'>${name}</span>`);
    this.nav.append(tab);
    var renderedTab = jQuery(
      `<div id='tab_${this.identifier}_${name}' style='display: ${selected ? "block" : "none"}'></div>`,
    ).append(content);
    this.contentHolder.append(renderedTab);

    return tab;
  }

  selectTab(name) {
    this.nav.find("input:radio[data-behaviour=tabstate]:checked").prop("checked", false);
    this.nav.find(`[data-tab-name='${name}'] [data-behaviour=tabstate]`).prop("checked", true);
    this.nav.find("input:radio[data-behaviour=tabstate]:checked").trigger("change");
  }

  removeTabs() {
    this.nav.children().detach();
    jQuery(this.contentHolder).children().detach();
  }
}

window.TabBuilder = TabBuilder;
